import script from "./NewsCenter.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsCenter.vue?vue&type=script&setup=true&lang=ts"

import "./NewsCenter.vue?vue&type=style&index=0&id=01c419e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c419e2"]])

export default __exports__